import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventNotificationGroup extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventNotificationGroup';

    // Define default properties here
    static instanceDefaults() {
        return {
            name: null,
            eventId: null,
        }
    }

    // static setupInstance(data, { models }) {
    //     if (data.items) {
    //         data.items = new models.api.NotificationGroup(data.NotificationGroup)
    //     }
    //     return data
    // }
}

const servicePath = 'notification-groups';
const servicePlugin = makeServicePlugin({
    Model: EventNotificationGroup,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin